import React from 'react'
import Checkbox from './Checkbox/Checkbox'
import Label from './Input/Label'

export const Input = props => {
  return (
    <div className={`input-checkbox`}>
      <Label {...props} />
      <Checkbox
        {...props}
        checked={!!(props.value || props.data)}
        onChange={props.onValueChange}
        label={` `}
      />
    </div>
  )
}

export const Output = props => {
  return (
    <div
      style={{
        width: '100%'
      }}
    >
      <Checkbox
        {...props}
        checked={!!(props.value || props.data)}
        onChange={props.onValueChange}
        label={` `}
      />
    </div>
  )
}
